import { GridBaseDataProvider } from '../../../grid/GridBaseDataProvider';
import {
  Column,
  ColumnKeys,
  DEFAULT_PAGE_NUMBER,
  DEFAULT_PAGE_SIZE,
  ResponseGridGetRowsResponse,
  ResponseGridResponse,
} from '../types';
import {
  GetRowsRequest,
  GetSummaryRequest,
  GetSummaryResponse,
  SetFiltersRequest,
  UpdateSettingsRequest,
  UpdateSettingsResponse,
} from '../../../grid/types/common';
import { ConsoleRequest, DataProviderType } from '../../../utils/request';
import { convertGridFiltersToExtJsFilters } from '../../../grid/utils/filters';
import { sanitizeObject } from '../../../utils/sanitization.utils';
import { translateFn } from '../../../utils/translator.helper';

export class ResponseGridDataProvider extends GridBaseDataProvider<Column, ColumnKeys> {
  private response: ResponseGridResponse;

  public constructor(private incidentId: string) {
    super();
  }

  public async getSummary(request: GetSummaryRequest<ColumnKeys>): Promise<GetSummaryResponse> {
    this.response = await ConsoleRequest.createRequest<ResponseGridResponse>({
      dataProviderType: DataProviderType.CORE,
      endpoint: 'EdrResponseActions',
      method: 'readRecords',
      payload: {
        page: request.pageNumber ?? DEFAULT_PAGE_NUMBER,
        limit: request.pageSize ?? DEFAULT_PAGE_SIZE,
        sort: request.sortColumnName ?? null,
        dir: request.sortDirection ?? null,
        filter: convertGridFiltersToExtJsFilters(request.filters),
        incidentId: this.incidentId,
      },
    });

    return sanitizeObject({
      summary: translateFn('{itemsCount} items', { itemsCount: this.response.total }),
      numItems: this.response.total,
    });
  }

  public async getRows(request: GetRowsRequest<Column, ColumnKeys>): Promise<ResponseGridGetRowsResponse> {
    return sanitizeObject({ rawEvents: this.response.data });
  }

  public async updateSettings(params: UpdateSettingsRequest<Column>): Promise<UpdateSettingsResponse> {
    return {};
  }

  public async setFilters(request: SetFiltersRequest<ColumnKeys>): Promise<{} | undefined> {
    return undefined;
  }
}
